<template>
    <k-panel class="border">
        <k-panel-header slot="header">{{ $t("autoInvestment") }}</k-panel-header>
        <div class="mb-3">
            <ul class="list-disc pl-4" v-html="$t('autoInvestmentDesc')">
            </ul>
        </div>
        <div slot="footer" class="text-center mt-5">
            <router-link :to="{name: navigateParams.name, params: navigateParams.params}">
                <a-button type="primary">{{ $t("createAutoInvestment") }}</a-button>
            </router-link>
        </div>
    </k-panel>
</template>

<script>
    export default {
        components: {},
        props: {
            navigateParams: {
                type: Object,
                default: () => {
                    return {
                        name: 'autoinvestment-strategy',
                        params: {}
                    };
                }
            }
        },
        data() {
            return {};
        }
    };
</script>


